<template>
  <p>Workflows</p>
</template>

<script>
export default {};
</script>

<style scoped>
</style>